import React from 'react';
import OrgWiseCostingForm from '../../../../components/costing/org-wise-costing';
import HeaderTitle from '../../../../components/typography/header-title';

export default function OrgWiseCosting() {
    return (
        <>
            <HeaderTitle
                title={'Org-wise Costing'}
                subtitle={
                    'Select vertical, periodicity, and date range for org-level costing views'
                }
            />
            <OrgWiseCostingForm />
        </>
    );
}
